<ng-container *adaptLoadingUntilFirstEmit="let team of team$">
    @if (team) {
        <!-- so that we won't see the error toaster if accessing invalid/delete team before redirected away -->
        <adapt-toolbar-title>
            <div class="d-flex align-items-center h2 mb-0">
                <adapt-link-team [team]="team"
                                 [showIcon]="true"
                                 [showLabels]="true"
                                 [adaptLinkDisabled]="true"></adapt-link-team>
            </div>
        </adapt-toolbar-title>
        <div *adaptIfAuthorised="ReadTeam;Entity:team"
             adaptToolbarContent
             alignment="right"
             [ordinal]="-2">
            <button adaptButtonIcon="fal fa-fw fa-rss"
                    [adaptBlockingClick]="viewActivityFeed"
                    data-test="view-activity-feed-button">View activity feed</button>
        </div>
        <div adaptToolbarContent>
            <ng-container *adaptIfAuthorised="ConfigureTeam; entity: team">
                @if (!team.isActive()) {
                    <button [adaptBlockingClick]="reactivateTeam"
                            adaptButtonIcon="fal fa-power-off"
                            [unsubscribeOnDestroy]="false">Reactivate group</button>
                }
                <a [routerLink]="teamConfigureLink$ | async"
                   adaptButton="configureLink"
                   adaptTooltip="Go to group configuration"
                   data-test="team-configure-link"></a>
            </ng-container>
        </div>
        <adapt-toolbar-inactive [entity]="team"
                                type="group">
        </adapt-toolbar-inactive>

        <adapt-layout-manager innerClass="h-100"
                              [fullPage]="false"
                              [allowEditing]="canEdit"
                              [useHiddenComponentMenu]="true"
                              [entity]="team">
            @if (team.isKeyFunction || team.isValueStream) {
                <adapt-layout-column class="col-md-8">
                    <ng-container *ngTemplateOutlet="guidanceTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="accountabilitiesTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="visionTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="valuesTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="systemsTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="objectivesTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="actionsTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="assessmentTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="activityFeedTemplate; context: { defaultUserHidden: true }"></ng-container>
                </adapt-layout-column>

                <adapt-layout-column class="col-md-4">
                    <ng-container *ngTemplateOutlet="peopleTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="rolesTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="locationTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="journeyProgressTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="externalDashboardsTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="systemOverviewTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="meetingsTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="meetingGuidanceTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="peerCatchUpsTemplate; context: { defaultUserHidden: true }"></ng-container>
                </adapt-layout-column>
            } @else {
                <adapt-layout-column class="col-md-4">
                    <ng-container *ngTemplateOutlet="peopleTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="rolesTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="locationTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="journeyProgressTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="externalDashboardsTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="systemOverviewTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="meetingsTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="meetingGuidanceTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="peerCatchUpsTemplate; context: { defaultUserHidden: true }"></ng-container>
                </adapt-layout-column>

                <adapt-layout-column class="col-md-8">
                    <ng-container *ngTemplateOutlet="visionTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="valuesTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="guidanceTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="accountabilitiesTemplate"></ng-container>
                    <ng-container *ngTemplateOutlet="systemsTemplate; context: { defaultUserHidden: !hasSystems }"></ng-container>
                    <ng-container *ngTemplateOutlet="objectivesTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="actionsTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="assessmentTemplate; context: { defaultUserHidden: true }"></ng-container>
                    <ng-container *ngTemplateOutlet="activityFeedTemplate; context: { defaultUserHidden: true }"></ng-container>
                </adapt-layout-column>
            }

            <ng-template #guidanceTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadPurposeVision;Entity:team"
                                        id="team-guidance"
                                        displayName="Guidance"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-guidance-dashboard-element [team]="team"
                                                           data-test="purpose-dashboard-element">
                    </adapt-team-guidance-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #accountabilitiesTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadTeam;Entity:team"
                                        id="team-accountabilities"
                                        displayName="Accountabilities"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-accountabilities-dashboard-element [team]="team"
                                                                   data-test="accountabilities-dashboard-element">
                    </adapt-team-accountabilities-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #systemsTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadSystem;Entity:team"
                                        id="team-systems"
                                        displayName="Systems (details)"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-universal-dashboard-element name="Systems"
                                                       [url]="systemsUrl$ | async">
                        <adapt-display-systems class="d-block mb-3"
                                               [fullPageCTA]="false"
                                               [team]="team"></adapt-display-systems>
                    </adapt-universal-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #visionTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadVision;Entity:team"
                                        id="team-vision"
                                        displayName="Vision"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-vision-dashboard-element [team]="team"
                                                         class="col-12 col-md-6"></adapt-team-vision-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #journeyProgressTemplate>
                @if (team.teamType === TeamType.Owner) {
                    <adapt-layout-component *adaptIfAuthorised="ReadJourneyProgress"
                                            id="team-journey-progress"
                                            displayName="Journey progress">
                        <adapt-journey-progress-dashboard-element></adapt-journey-progress-dashboard-element>
                    </adapt-layout-component>
                }
            </ng-template>

            <ng-template #valuesTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadValuesConstitution;Entity:team"
                                        id="team-values"
                                        displayName="Values"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-values-constitution-dashboard-element [team]="team"
                                                                 class="col-12 col-md-6">
                    </adapt-values-constitution-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #objectivesTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadObjectivesForTeam;Entity:team"
                                        id="team-objectives"
                                        displayName="Objectives & key results"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-objectives-tree-dashboard-element [team]="team"
                                                             [isCompactView]="true"></adapt-objectives-tree-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #actionsTemplate
                         let-defaultUserHidden="defaultUserHidden">
                @if (hasStats) {
                    <adapt-layout-component id="team-actions"
                                            displayName="Actions"
                                            [defaultUserHidden]="defaultUserHidden">
                        <adapt-team-work-dashboard-element [team]="team"></adapt-team-work-dashboard-element>
                    </adapt-layout-component>
                }
            </ng-template>

            <ng-template #assessmentTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadTeamAssessment;Entity:team"
                                        id="team-assessment"
                                        displayName="Team assessment"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-assessment-dashboard-element [team]="team"></adapt-team-assessment-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #activityFeedTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadTeam;Entity:team"
                                        id="team-activity-feed"
                                        displayName="Activity feed"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-dashboard-element name="{{team?.name}} team activity">
                        <adapt-team-activity-feed [team]="team"
                                                  feedTitle=""></adapt-team-activity-feed>
                    </adapt-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #peopleTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="PlatformStandardRead"
                                        id="team-people"
                                        displayName="People"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-people-dashboard-element [team]="team"></adapt-team-people-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #rolesTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="PlatformStandardRead"
                                        id="team-roles"
                                        displayName="Roles"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-roles [team]="team"
                                      data-test="team-roles-dashboard-element"></adapt-team-roles>
                </adapt-layout-component>
            </ng-template>

            <ng-template #locationTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="PlatformStandardRead"
                                        id="team-location"
                                        displayName="Location"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-location-dashboard-element [team]="team"></adapt-team-location-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #systemOverviewTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadSystem;Entity:team"
                                        id="team-system-overview"
                                        displayName="Systems (overview)"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-systems-dashboard-element [team]="team"></adapt-team-systems-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #externalDashboardsTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ViewExternalDashboard;Entity:team"
                                        id="team-external-dashboards"
                                        displayName="External dashboards"
                                        [defaultUserHidden]="defaultUserHidden">
                    <!-- element is ngIf'd when no external dashboards -->
                    <adapt-external-dashboard-dashboard-element *adaptLayoutComponentEnabled="true"
                                                                [team]="team"></adapt-external-dashboard-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #meetingsTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadTeamMeetings;Entity:team"
                                        id="team-meetings"
                                        displayName="Meetings"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-meetings-dashboard-element [team]="team"></adapt-team-meetings-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #meetingGuidanceTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadTeamMeetings;Entity:team"
                                        id="team-meeting-guidance"
                                        displayName="Meeting guidance"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-team-meeting-guidance-dashboard-element [team]="team">
                    </adapt-team-meeting-guidance-dashboard-element>
                </adapt-layout-component>
            </ng-template>

            <ng-template #peerCatchUpsTemplate
                         let-defaultUserHidden="defaultUserHidden">
                <adapt-layout-component *adaptIfAuthorised="ReadAllPeerCatchups;Entity:team"
                                        id="team-peer-catch-ups"
                                        displayName="Peer Catch-ups"
                                        [defaultUserHidden]="defaultUserHidden">
                    <adapt-peer-catch-up-dashboard-element [team]="team"></adapt-peer-catch-up-dashboard-element>
                </adapt-layout-component>
            </ng-template>
        </adapt-layout-manager>
    }
</ng-container>
